import React, { useEffect } from 'react';
import { PRIMARY_DOMAIN } from '@/config/domain';

const isLovableHost = (host: string) => {
  const suffixes = ['.lovable.app', '.lovableproject.com'];
  return suffixes.some((s) => host.endsWith(s));
};

const DomainGuard: React.FC = () => {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const { hostname, protocol, pathname, search, hash } = window.location;

    if (!PRIMARY_DOMAIN) return; // not configured yet
    if (hostname === PRIMARY_DOMAIN) return; // already on primary

    // Only redirect from Lovable staging/project domains
    if (isLovableHost(hostname)) {
      const target = `${protocol}//${PRIMARY_DOMAIN}${pathname}${search}${hash}`;
      if (target !== window.location.href) {
        window.location.replace(target);
      }
    }
  }, []);

  return null;
};

export default DomainGuard;
